export default {
    methods: {
        formatValue(valor, min = 2, max = 2) {
            if (typeof valor === "string" && valor.trim() !== "" && !isNaN(valor)) {
                valor = Number(valor);
            }

            if (typeof valor !== "number" || isNaN(valor) || !isFinite(valor)) {
                return '';
            }

            if (Number.isInteger(valor)) {
                return new Intl.NumberFormat("pt-BR").format(valor);
            }

            if (valor.toString().split(".")[1]?.length === 1) {
                min = 1;
                max = 1;
            }

            return new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: min,
                maximumFractionDigits: max
            }).format(valor);
        },
        formatPercent(value) {
            return (value * 100).toFixed(2);
        },
        formatDecimals(val, digits = 2, decimalFormat = true) {
            let formattedVal = val.toFixed(digits).replace(/[.]00$/, "")
            return decimalFormat ? formattedVal.replace('.', ',') : formattedVal
        }
    }
}
